module.exports = __webpack_public_path__ + "static/media/video.d9a2c0e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/video.svg
// module id = 282
// module chunks = 0